import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface IActivateTrialResponse {
  message: string;
  trial_days: number;
  trial_end: string;
  is_vip: boolean;
  subscription_status: string;
}

export const useActivateTrial = () => {
  return useMutation<IActivateTrialResponse, Error, void>({
    mutationFn: async () => {
      return await httpService.post<IActivateTrialResponse>(
        API_CONFIG.path.stripeActivateTrial,
        {}
      );
    },
  });
};
